module.exports = __webpack_public_path__ + "img/word.337fcdc7.svg";